/** Canonical production origin. Used for sitemap, robots, and Open Graph URLs. */
export const SITE_URL = "https://millsengraving.com";
export const SITE_NAME = "Mills Engraving";

export function absoluteUrl(path = "/"): string {
  if (path.startsWith("https://") || path.startsWith("http://")) {
    return path;
  }
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${normalized}`;
}
